import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.19.11_db0@0.3.2_eslint@_hs5fzpigcqitedqqy7o6b3beea/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}